<template>
    <div class="container pt-2">
        <PageTitle main="Vincular Carga Por tipo de Caminhão" sub="Cadastrar ou deletar relação de carga e caminhão" />
        <b-form>
            <input id="carga_caminhao-id" type="hidden" v-model="carga_caminhao.id" />
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Tipo de Caminhão:" label-for="carga_caminhao-caminhao">
                        <b-form-select id="carga_caminhao-caminhao" :options="caminhaos" v-model="carga_caminhao.caminhao" 
                        :class="{ 'inputError': $v.carga_caminhao.caminhao.$error }"
                        class="textInput"
                        @keydown.tab="$v.carga_caminhao.caminhao.$touch"/>
                        <span class="error" v-if="!$v.carga_caminhao.caminhao.required && $v.carga_caminhao.caminhao.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Tipo de Carga:" label-for="carga_caminhao-carga">
                        <b-form-select id="carga_caminhao-carga" :options="cargas" v-model="carga_caminhao.carga" 
                        :class="{ 'inputError': $v.carga_caminhao.carga.$error }"
                        class="textInput"
                        @keydown.tab="$v.carga_caminhao.carga.$touch"/>
                        <span class="error" v-if="!$v.carga_caminhao.carga.required && $v.carga_caminhao.carga.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" @click="save" class="mt-3 botaoInput">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 mt-3 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-carga_caminhaos" 
                class="text-center table table-sm" 
                :items="carga_caminhaos.length>0?carga_caminhaos:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-carga_caminhaos"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-carga_caminhaos" 
                class="text-center table table-sm" 
                :items="carga_caminhaos.length>0?carga_caminhaos:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-carga_caminhaos"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { required } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'carga_caminhaos',
    components: { PageTitle },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            level: '',
            carga_caminhao: {},
            carga_caminhaos: [],
            fields: [
                { key: 'caminhao_titulo', label: 'Tipo de Caminhão', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'carga_titulo', label: 'Tipo de Carga', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            carga: {},
            cargas: [],
            caminhao: {},
            caminhaos: []
        }
    },
    validations: {
        carga_caminhao: {
            caminhao: {
                required
            },
            carga: {
                required
            }
        }
    },
    computed: {
        rows() {
            return this.carga_caminhaos.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadCargas() {
            const url = `${baseApiUrl}/backend/tipo_carga.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.cargas = res.data.map(carga => {
                        return { ...carga, value: carga.id, text: carga.titulo }
                    })
                }else{
                    this.cargas.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadCaminhaos() {
            const url = `${baseApiUrl}/backend/tipo_caminhao.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.caminhaos = res.data.map(caminhao => {
                        return { ...caminhao, value: caminhao.id, text: caminhao.titulo }
                    })
                }else{
                    this.caminhaos.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadCarga_caminhaos() {
            const url = `${baseApiUrl}/backend/carga_caminhao.php`
            axios.get(url).then(res => {
                this.carga_caminhaos = res.data
                if(this.carga_caminhaos.length > 0){
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        reset() {
            this.carga_caminhao = {}
            this.loadCarga_caminhaos()
            this.$v.carga_caminhao.$reset()
        },
        save() {
            this.$v.carga_caminhao.$touch()
            if(!this.$v.carga_caminhao.$error){
                axios['post'](`${baseApiUrl}/backend/carga_caminhao.php`, this.carga_caminhao)
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Vinculo inserido com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(carga_caminhao) {
            const sure = confirm("Deseja realmente excluir o vinculo?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/carga_caminhao.php`
                axios.delete(url, { data: carga_caminhao })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Vinculo excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadCarga_caminhao(carga_caminhao) {
            this.carga_caminhao = { ...carga_caminhao }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        }
        this.loadCarga_caminhaos()
        this.loadCargas()
        this.loadCaminhaos()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.carga_caminhaos.length
    }
}
</script>

<style>
</style>
